<template>
	<v-container>
		<v-row>
			<v-col
					v-if="$vuetify.breakpoint.mdAndUp"
					lg="4"
					md="4"
					xl="4"
			>
				<preferences-sidebar
						:rounded="$vuetify.breakpoint.smAndDown ? '0' : 'lg'"
				/>
			</v-col>
			<v-col
					class="px-sm-only-0 px-xs-0"
					lg="8"
					md="8"
					xl="8"
			>
				<router-view class="mt-4" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import PreferencesSidebar from "@/views/preferences/PreferencesSidebar.vue";

export default {
  components: { PreferencesSidebar },
};
</script>
